import './style.scss';

import { format } from 'date-fns';
import { NumberUtils } from 'modules';
import React from 'react';
import { forwardRef } from 'react';

const PrintA4Invoice = (
  {
    data,
  }: {
    data?: any;
  },
  ref: any,
) => {
  const period = data?.transaction?.period;
  const month = String(period)?.slice?.(4, 6) || '';
  const year = String(period)?.slice?.(0, 4) || '';

  return (
    <table
      className='print-order-table-container'
      ref={ref}
      // align="center"
      // border={0}
      cellPadding={0}
      cellSpacing={0}
      style={{
        margin: 0,
        padding: 0,
        border: 0,
        textAlign: 'center',
        backgroundColor: '',
        width: '100% !important',
        fontFamily: 'Roboto',
        fontSize: '16px',
        lineHeight: '30px',
        color: '#000',
      }}
      width='100%'
    >
      <tbody>
        <tr>
          <td align='center' valign='top'>
            <table
              // border={0}
              cellPadding={0}
              cellSpacing={0}
              style={{ marginTop: 15, background: '#FFFFFF' }}
              width={680}
            >
              <tbody>
                <tr>
                  <td>
                    <table
                      cellPadding={0}
                      cellSpacing={0}
                      style={{
                        background: '#F9F9FA',
                        padding: '10px 20px',
                        borderBottom: '2px solid #f2f2f2',
                        width: '100%',
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ width: '30%' }}>
                            <img
                              src='https://ecollect.vitapay.vn/assets/news/images/logo-login.svg'
                              style={{
                                maxWidth: 140,
                                maxHeight: 70,
                                verticalAlign: 'middle',
                              }}
                            />
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <p>
                              Mã giao dịch:{' '}
                              <span style={{ fontWeight: 'bold' }}>
                                {data?.transaction?.transactionCode}
                              </span>
                            </p>
                            <p>
                              Thời gian:{' '}
                              <span style={{ fontWeight: 'bold' }}>
                                {data?.transaction?.payAt
                                  ? format(
                                      new Date(data?.transaction?.payAt),
                                      'HH:mm:ss dd/MM/yyyy',
                                    )
                                  : ''}
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table
                      cellPadding={0}
                      cellSpacing={0}
                      style={{
                        padding: '5px 20px',
                        borderBottom: '2px solid #f2f2f2',
                      }}
                      width='100%'
                    >
                      <tbody>
                        <tr>
                          <td style={{ textAlign: 'center' }}>
                            <div
                              style={{
                                fontSize: 36,
                                lineHeight: '40px',
                                color: '#1A1E35',
                                fontWeight: 600,
                                marginBottom: 5,
                              }}
                            >
                              Biên nhận thanh toán
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table
                      className='info'
                      cellPadding={5}
                      cellSpacing={0}
                      style={{ padding: '20px 20px 50px 20px' }}
                      width='100%'
                    >
                      <tbody>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Mã khách hàng</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>{data?.customer?.customerCode || ''}</div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Tên khách hàng</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>{data?.customer?.fullName || ''}</div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Địa chỉ</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>{data?.customer?.address || ''}</div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Dịch vụ</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>
                              {data?.transaction?.transactionType || ''}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Nhà cung cấp</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>
                              {data?.transaction?.elecProductName || ''}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Kỳ thanh toán</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              padding: '5px',
                            }}
                          >
                            <div>{`${month}/${year}`}</div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width='40%'
                            style={{
                              backgroundColor: '#d7d7cb',
                              padding: '5px',
                            }}
                          >
                            <div>Giá trị hóa đơn</div>
                          </td>
                          <td
                            width='60%'
                            style={{
                              textAlign: 'right',
                              backgroundColor: '#e7e7c1',
                              fontWeight: 'bold',
                              padding: '5px',
                            }}
                          >
                            <div>
                              {NumberUtils.toCurrency(
                                data?.transaction?.value,
                                'vnđ',
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table
                      cellPadding={0}
                      cellSpacing={0}
                      style={{
                        padding: '10px 20px',
                        borderTop: '2px solid #E1E1E3',
                        background: '#F9F9FA',
                      }}
                      width='100%'
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontSize: 14,
                              lineHeight: '32px',
                              fontWeight: 'bold',
                              color: '#1A1E35',
                            }}
                          />
                        </tr>
                        <tr>
                          <td
                            style={{ padding: '5px 0px', textAlign: 'right' }}
                          >
                            Ngày thu:{' '}
                            {data?.transaction?.payAt
                              ? format(
                                  new Date(data?.transaction?.payAt),
                                  'dd/MM/yyyy',
                                )
                              : ''}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: '5px 0px 70px 5px',
                              textAlign: 'right',
                            }}
                          >
                            Người thu tiền
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              fontSize: 16,
                              lineHeight: '36px',
                              fontWeight: 'bold',
                              color: '#1A1E35',
                              textAlign: 'right',
                            }}
                          >
                            {data?.execBy?.fullName}
                            {/* Lê Thị Ly Tâm */}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: '0px 0px 50px 0px',
                              fontSize: 12,
                            }}
                          >
                            ĐT hỗ trợ:{' '}
                            <b>
                              {data?.execBy?.phoneNumber?.replace(/\+84/, '0')}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default forwardRef(PrintA4Invoice);
